module.exports = __webpack_public_path__ + "static/media/document.ce7c66e7.svg";